import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StudentList from './StudentList';
import StudentForm from './StudentForm';
import DeletedStudentsList from './DeletedStudentsList';

const Students = () => {
  return (
    <Routes>
      <Route path="/" element={<StudentList />} />
      <Route path="/new" element={<StudentForm />} />
      <Route path="/:id/edit" element={<StudentForm />} />
      <Route path="/deleted" element={<DeletedStudentsList />} />
      <Route path="*" element={<Navigate to="/students" replace />} />
    </Routes>
  );
};

export default Students;
